import React, { useEffect, useState, useRef } from 'react';
import { Plus, Pencil, Trash2, X, Check, Upload } from 'lucide-react';
import { membroService } from '../../services/api';
import toast from 'react-hot-toast';

const TIPOS  = ['diretoria','conselho'];

export default function AdminMembros() {
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState<'criar'|'editar'|null>(null);
  const [current, setCurrent] = useState<any>(null);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({ nome:'', cargo:'', tipo:'diretoria', bio:'' });
  const [imgFile, setImgFile] = useState<File|null>(null);
  const [imgPrev, setImgPrev] = useState('');
  const fileRef = useRef<HTMLInputElement>(null);

  const load = () => { setLoading(true); membroService.listar().then(r=>setItems(Array.isArray(r.data)?r.data:r.data.membros||[])).catch(()=>toast.error('Erro')).finally(()=>setLoading(false)); };
  useEffect(load,[]);
  const openCriar = () => { setForm({nome:'',cargo:'',tipo:'diretoria',bio:''});setImgFile(null);setImgPrev('');setCurrent(null);setModal('criar'); };
  const openEditar = (item:any) => { setForm({nome:item.nome,cargo:item.cargo||'',tipo:item.tipo||'diretoria',bio:item.bio||''});setImgPrev(item.fotoUrl||'');setImgFile(null);setCurrent(item);setModal('editar'); };
  const onChange = (e:any) => setForm(f=>({...f,[e.target.name]:e.target.value}));
  const onFile = (e:any) => { const f=e.target.files?.[0];if(f){setImgFile(f);setImgPrev(URL.createObjectURL(f));} };

  const salvar = async () => {
    setSaving(true);
    try {
      const fd=new FormData(); Object.entries(form).forEach(([k,v])=>fd.append(k,v as string)); if(imgFile) fd.append('foto',imgFile);
      if(modal==='criar') await membroService.criar(fd); else await membroService.atualizar(current._id,fd);
      toast.success('Salvo!'); setModal(null); load();
    } catch { toast.error('Erro.'); } finally { setSaving(false); }
  };
  const deletar = async (id:string) => { if(!window.confirm('Excluir membro?')) return; try { await membroService.deletar(id); toast.success('Excluído!'); load(); } catch { toast.error('Erro.'); } };

  return (
    <div>
      <div className="admin-page-header"><h1>Membros</h1><button className="btn btn-primary" onClick={openCriar}><Plus size={17}/> Novo membro</button></div>
      {loading ? <div className="loading-center"><div className="spinner"/></div> : (
        <div style={{overflowX:'auto'}}>
          <table className="admin-table">
            <thead><tr><th>Foto</th><th>Nome</th><th>Cargo</th><th>Tipo</th><th>Ações</th></tr></thead>
            <tbody>
              {items.length===0&&<tr><td colSpan={5} style={{textAlign:'center',padding:32,color:'var(--texto-leve)'}}>Nenhum membro.</td></tr>}
              {items.map(item=>(
                <tr key={item._id}>
                  <td>{item.fotoUrl?<img src={item.fotoUrl} alt="" style={{width:40,height:40,borderRadius:'50%',objectFit:'cover'}}/>:<div style={{width:40,height:40,borderRadius:'50%',background:'var(--creme-escuro)',display:'flex',alignItems:'center',justifyContent:'center',fontWeight:700,color:'var(--laranja)'}}>{item.nome?.charAt(0)}</div>}</td>
                  <td style={{fontWeight:600,fontSize:'0.9rem'}}>{item.nome}</td>
                  <td>{item.cargo}</td>
                  <td><span className={`badge ${item.tipo==='conselho'?'badge-turquesa':'badge-laranja'}`}>{item.tipo}</span></td>
                  <td><div className="actions">
                    <button className="btn btn-outline btn-sm" onClick={()=>openEditar(item)}><Pencil size={14}/></button>
                    <button className="btn btn-sm" style={{background:'#fee2e2',color:'#b91c1c',borderRadius:'var(--radius)'}} onClick={()=>deletar(item._id)}><Trash2 size={14}/></button>
                  </div></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {modal&&(
        <div className="admin-modal-overlay" onClick={()=>setModal(null)}>
          <div className="admin-modal" style={{maxWidth:520}} onClick={e=>e.stopPropagation()}>
            <div className="admin-modal-header"><h3>{modal==='criar'?'Novo Membro':'Editar Membro'}</h3><button className="modal-close" onClick={()=>setModal(null)}><X size={20}/></button></div>
            <div className="admin-modal-body">
              <div className="form-group">
                <label className="form-label">Foto</label>
                <div className="img-upload-area" style={{height:120,width:120,borderRadius:'50%',margin:'0 auto'}} onClick={()=>fileRef.current?.click()}>
                  {imgPrev?<img src={imgPrev} alt="" style={{width:'100%',height:'100%',objectFit:'cover',borderRadius:'50%'}}/>:<div className="img-upload-placeholder"><Upload size={20}/></div>}
                </div>
                <input ref={fileRef} type="file" accept="image/*" style={{display:'none'}} onChange={onFile}/>
              </div>
              <div className="form-row-2">
                <div className="form-group"><label className="form-label">Nome *</label><input name="nome" value={form.nome} onChange={onChange} className="form-control" required/></div>
                <div className="form-group"><label className="form-label">Tipo</label><select name="tipo" value={form.tipo} onChange={onChange} className="form-control">{TIPOS.map(t=><option key={t} value={t}>{t}</option>)}</select></div>
              </div>
              <div className="form-group"><label className="form-label">Cargo</label><input name="cargo" value={form.cargo} onChange={onChange} className="form-control" placeholder="Presidente, Secretário…"/></div>
              <div className="form-group"><label className="form-label">Bio</label><textarea name="bio" value={form.bio} onChange={onChange} className="form-control" rows={3} placeholder="Breve apresentação"/></div>
            </div>
            <div className="admin-modal-footer">
              <button className="btn btn-outline" onClick={()=>setModal(null)}>Cancelar</button>
              <button className="btn btn-primary" onClick={salvar} disabled={saving}>{saving?'Salvando…':<><Check size={16}/> Salvar</>}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}